var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhrOutlineFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4514_222",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H32V32H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4514_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3359 4.1875H20.502C22.1588 4.1875 23.502 5.53062 23.502 7.1875C23.502 8.84438 22.1588 10.1875 20.502 10.1875H17.3359C15.6791 10.1875 14.3359 8.84438 14.3359 7.1875C14.3359 5.53062 15.6791 4.1875 17.3359 4.1875Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6606 26.7202C29.6802 28.4896 27.7938 29.6875 25.6276 29.6875H12.0859",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 18.1878H25.625C27.8329 18.1878 29.7501 19.4321 30.7136 21.2578",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 11.6715C11.2802 10.7662 12.4009 10.1875 13.6567 10.1875H24.3717C26.5809 10.1875 28.3717 11.9783 28.3717 14.1875C28.3717 16.3966 26.5809 18.1875 24.3717 18.1875H14.9967",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4779 19.1143C14.7161 17.8661 13.6222 16.8426 12.3192 16.1666H4.95169C2.38131 17.5001 0.625 20.1854 0.625 23.2811C0.625 25.9004 1.88225 28.2258 3.826 29.6874H13.2812",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6373 9.41798L8.6318 9.42492L6.61011 11.9672C5.78999 12.9985 5.87418 14.4789 6.80593 15.4106C7.81574 16.4204 9.45886 16.4204 10.4687 15.4106C11.4004 14.4789 11.4846 12.9985 10.6645 11.9672L8.6373 9.41798Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63281 16.168V13.492",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.095 23.3477C17.8167 21.6282 16.8569 20.1374 15.5023 19.1595C14.1549 20.1322 13.1981 21.6123 12.9141 23.3203",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3847 24.0188C15.8638 25.5398 15.2643 27.6319 15.5829 29.6046C17.5556 29.9232 19.6477 29.3237 21.1687 27.8028C22.6896 26.2818 23.2891 24.1897 22.9705 22.217C20.9978 21.8984 18.9057 22.4979 17.3847 24.0188Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6218 24.0188C15.1427 25.5398 15.7422 27.6319 15.4236 29.6046C13.4509 29.9232 11.3588 29.3237 9.83785 27.8028C8.31691 26.2818 7.71741 24.1897 8.03604 22.217C10.0087 21.8984 12.1009 22.4979 13.6218 24.0188Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56466 2.3125C4.87428 3.00288 4.87428 4.12213 5.56466 4.8125C6.25503 5.50288 6.25503 6.62213 5.56466 7.3125",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22872 4.8125C1.53834 5.50288 1.53834 6.62213 2.22872 7.3125C2.91909 8.00288 2.91909 9.12213 2.22872 9.8125",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrOutlineFour);
export default __webpack_public_path__ + "static/media/ahr-outline-four.2f82bf692c3071f1fe9c8161a5f5b1bc.svg";
export { ForwardRef as ReactComponent };